module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answers",
    class: _vm.type,
    attrs: {
      "data-popup": _vm.popup
    }
  }, [_c('transition-group', {
    staticClass: "answer-cards",
    attrs: {
      "id": "answer-cards",
      "name": "staggered-fade",
      "tag": "ul",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.answers), function(answer, index) {
    return _c('li', {
      key: index,
      staticClass: "answer-card",
      class: {
        'correct': answer.points
      },
      style: ({
        width: _vm.width()
      }),
      on: {
        "click": function($event) {
          _vm.expand(index)
        }
      }
    }, [_c('div', {
      staticClass: "points"
    }, [_c('span', [_vm._v(_vm._s(answer.points))]), _vm._v(" punten")]), _vm._v(" "), _c('div', {
      staticClass: "ac-question"
    }, [_vm._v(_vm._s(answer.question))]), _vm._v(" "), _c('div', {
      staticClass: "answer"
    }, [_vm._v("Jij zei: "), _c('span', [_vm._v(_vm._s(answer.answer))])])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b3f43fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Answers.vue
// module id = 114
// module chunks = 1